import React from "react";
import cx from "classnames";

export default function CardPm({ img, desc, name, post, cardVisi }) {
  const classes = cx({
    "space-y-5 justify-center flex flex-col xl:flex-row text-center xl:text-start xl:justify-start xl:space-y-0 items-center p-6 space-x-5 rounded-2xl text-white ": true,
    "bg-primary": cardVisi ? false : true,
    "bg-white text-articleTitle border border-borderCardFeatures": cardVisi
      ? true
      : false,
  });
  return (
    <div className="p-4 hover:border-primary hover:border rounded-2xl hover:bg-white">
      <div className={classes}>
        <img
          crossOrigin="anonymous"
          src={img}
          alt={desc}
          className="xl:w-[200px] xl:h-[200px] rounded-3xl "
        />
        <div className="space-y-3 wrapperDetail">
          <div dangerouslySetInnerHTML={{ __html: post }} />
          {/* <span className="font-bold ">{post}</span> */}
          <h1 className="font-bold ">{name}</h1>
          <div dangerouslySetInnerHTML={{ __html: desc }} />
        </div>
      </div>
    </div>
  );
}
